import * as React from 'react';
import ReactModal from 'react-modal';
import { EmployeeProfileInfo } from '../../../interface/EmployeeReportInterface';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height: '70%',
        background: 'rgba(209,229,242,0.9)',
        border: 'none',
        fontSize: '1.5em'
    },
}

interface State {
    modalIsOpen: boolean;
}

class DisclaimerOverlay extends React.Component<EmployeeProfileInfo, State> {
    state = { modalIsOpen: true }
    handleCloseModal = () => {
        this.setState({ modalIsOpen: false })
    }
    render() {
        return (
            <div>

                <ReactModal
                    isOpen={this.state.modalIsOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                    onRequestClose={this.handleCloseModal}
                    shouldCloseOnOverlayClick={true}
                    ariaHideApp={false}
                >
                    <div onClick={this.handleCloseModal}>
                        <p>
                            Sponsored research grants are investments in scientific discovery and training. Grants enable investigators to hire people and purchase the goods and services necessary to pursue research work.
                </p>
                        <p>
                            One important way that new discoveries are applied in our economy and society is through the movements of research-trained people. This report uses data {this.props.agg ? `` : `your institution`} submitted to IRIS {this.props.agg ? `by member institutions` : ``} in concert with privacy-protected data from the U.S. Census Bureau to document the flow of research-trained individuals from employment on sponsored projects on {this.props.agg ? `university campuses` : `your campus`}, to later jobs in all sectors of the U.S. economy.
                </p>

                        <p>
                            These data describe employment and earnings of research-trained employees who have left {renderText(this.props.university)} between {renderText(this.props.year_first_left)} and {renderText(this.props.year_last_left)} for jobs in the United States.
                        </p>
                        <p>
                            You may share this report through the Share Report link. For more concrete information about your match rates and Census privacy procedures, click on the Match Report tab. The Methodology tab includes technical details about the data and our methods. For more concrete information about your match rates and Census privacy procedures please see the memo linked via Download Data. More general information about Census privacy and confidentiality procedures can be found at <a href="https://www.census.gov/privacy">https://www.census.gov/privacy</a>.
                </p>
                        <p>Click anywhere on this page to see your report.</p>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

export default DisclaimerOverlay;

const renderText = (string) => string ? string : <i className="fa fa-spinner"></i>;
